module.exports = __webpack_public_path__ + "static/img/partecs.20208dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/partecs.png
// module id = qbdR
// module chunks = 0